<div class="card border border-secondary mb-4 position-relative">
  <div *ngIf="errorService.hasErrors()" @flyInOut class="status-container error position-absolute d-flex align-items-center">
    <span class="material-symbols-outlined me-2"> cancel </span>
    <p *ngFor="let error of errorService.errors">{{ error }}</p>
  </div>
  <div
    class="status-container position-absolute d-flex align-items-center"
    [ngClass]="{ success: redemptionResult === successMessage, error: redemptionResult !== successMessage }"
    *ngIf="redemptionResult"
    @flyInOut
  >
    @if(redemptionResult === successMessage){
    <span class="success material-symbols-outlined text-success me-2"> check_circle </span>
    } @else {
    <span class="error material-symbols-outlined text-danger me-2"> cancel </span>
    }
    <p>{{ redemptionResult }}</p>
  </div>
  <div class="card-header">
    <img
      *ifScreenSize="screenSize.Mobile"
      class="w-100"
      [src]="'placeholders/vouchermobile.svg' | contentAssetImage"
      alt="Voucher"
    />
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-lg-5 col-12">
        <h5 class="mb-1 font-weight-bold text-white">
          {{ 'voucher.title' | translate }}
        </h5>
        <p>
          {{ 'voucher.description' | translate }}
        </p>
      </div>
      <div class="col-lg-4 col-12">
        <span class="input-group">
          <input
            type="text"
            [(ngModel)]="voucherCode"
            placeholder="Enter Code"
            class="form-control text-start gloss ps-5 px-lg-0"
            (keyup.enter)="redeemVoucher()"
          />
        </span>

        <button
          class="btn btn-white font-weight-bold w-100 py-0"
          type="button"
          (click)="redeemVoucher()"
          [disabled]="disableButton"
        >
          {{ 'voucher.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
